<template>
  <section class="sc-hero">
    <div class="sc-hero-bg">
      <div class="sc-hero-bg-img" />
      <div class="sc-hero-bg-gradient" />
    </div>
    <div class="sc-hero-banner">
      Multi-Week Discount: Get $80 Off Your 2nd Week
    </div>
    <div class="sc-hero-content">
      <p class="sc-hero-subtitle">
        Prevent Summer Slide
      </p>
      <h1 class="sc-hero-title">
        Join Think Zone<br>Academic Summer Camp
      </h1>
      <button
        v-track-leads-button="{ site: $LEADS_BUTTON_SITE.HERO, name: 'Schedule a Tour Today' }"
        type="button"
        class="sc-hero-btn"
        @click="$emit('schedule', $LEADS_BUTTON_SITE.HERO)"
      >
        Schedule a Tour Today
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SummerCampHero',
};
</script>

<style lang="scss" scoped>
.sc-hero {
  position: relative;
  width: 100%;
  height: 652px;
  overflow: hidden;
  font-family: 'Roboto-Flex', sans-serif;

  .sc-hero-bg {
    position: absolute;
    inset: 0;

    .sc-hero-bg-img {
      position: absolute;
      inset: 0;
      background-image: url('~assets/web/images/summerCamp/banner-bg.png');
      background-size: cover;
      background-position: center right;
    }

    // 左侧渐变遮罩，让左边文字区域可读
    .sc-hero-bg-gradient {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.72) 0%,
        rgba(0, 0, 0, 0.55) 30%,
        rgba(0, 0, 0, 0.15) 60%,
        rgba(0, 0, 0, 0) 100%
      );
    }
  }

  .sc-hero-content {
    position: relative;
    z-index: 1;
    height: 100%;
    max-width: 1920px;
    padding: 131px 244px 131px 310px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 41px;
  }

  .sc-hero-banner {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    background: url('~assets/web/images/summerCamp/bottom-bg.png') center / cover no-repeat;
    color: #fff;
    font-family: 'Roboto-Flex', sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    padding: 18px 0;
  }

  .sc-hero-subtitle {
    font-family: 'Roboto-Flex', sans-serif;
    font-size: 36px;
    font-weight: 700;
    line-height: 44px;
    letter-spacing: 1.08px;
    color: #fff;
    margin: 0;
  }

  .sc-hero-title {
    font-family: 'Roboto-Black', sans-serif;
    font-size: 64px;
    line-height: 72px;
    color: #fff;
    margin: 0;
  }

  .sc-hero-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 22px 48px;
    border-radius: 50px;
    background: var(--txt-color-link);
    border: none;
    color: #fff;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    font-family: 'Roboto-Flex', sans-serif;
    cursor: pointer;
    align-self: flex-start;
    transition: background-color 0.2s ease;

    &:hover {
      background: #c41e20;
    }
  }
}
</style>
